import React from "react";
import imageValentina from "../assets/Valentina-01.svg";
function SideImage() {
  return (
    <div>
      <img src={imageValentina} alt='Valentina Mango' className="" ></img>      
    </div>
  );
}

export default SideImage;
